<template>
<main id="main" class="reminder">
  <div class="wrap1160">
    <div class="remind-msg-comp">
      <p v-html="$t('CONTACT_COMPLETION_MESSAGE')"></p>
    </div>
  </div>
</main>
</template>

<script>

export default {
  props : {
    parent : {
      type    : Object,
      default : Object
    }
  }
}
</script>
